import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {  useTranslation } from 'react-i18next';


import { Nav, NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';

const ProfileBottomNavigation = (props) => {

    const { t } = useTranslation();

    const tabs = [{
        route: "/",
        icon: "pi pi-home",
        label: t('leftmenu_dashboad')
    }, {
        route: "/search",
        icon: "pi pi-search",
        label: t('global_btn_search')
    }, {
        route: "/login",
        icon: "pi pi-user",
        label: t('global_btn_login')
    }, {
        route: "/register",
        icon: "pi pi-user-edit",
        label: t('global_btn_membership')
    }]


    const navigate = useNavigate();


    return (
        <>
            <div>
                <div className="flex  justify-content-center align-items-center p-0 d-lg-none">
                    <a className="navbar-brand" href="/">
                        <img id="topbar-logo" src={`/assets/layout/images/logo-${props.colorScheme === 'light' ? 'light' : 'dark'}.png`} alt="vault-layout" className="logo" />

                    </a>
                </div>
                <nav className="navbar fixed-bottom navbar-light d-block d-lg-none bottom-tab-nav" role="navigation">
                    <Nav className="w-100">
                        <div className=" d-flex flex-row justify-content-around w-100">
                            {
                                tabs.map((tab, index) => (
                                    <NavItem key={`tab-${index}`} >
                                        <NavLink to={tab.route} className="nav-link bottom-nav-link" >
                                            <div className="row d-flex flex-column justify-content-center align-items-center">
                                                <i size="lg" className={tab.icon} />
                                                <div className="bottom-tab-label">{tab.label}</div>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                ))
                            }
                        </div>
                    </Nav>
                </nav>
            </div>


        </>
    );
};

export default ProfileBottomNavigation;
